import withSelectedInfluencers from 'components/common/withSelectedInfluencers';
import AddToList from 'components/common/lists/AddToList';

export default withSelectedInfluencers(AddToList);
